import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_checkmark",
  "use": "svg_checkmark-usage",
  "viewBox": "0 0 14 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 10\" id=\"svg_checkmark\"><path d=\"M13.622.918 4.837 9.704.29 5.148l.622-.622 3.926 3.933L12.985.311l.637.607Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol